import React, { useEffect } from 'react';

export interface TabsProps {
  children: React.ReactNode[];
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
  onTabChange?: (tab: string) => void;
  clickableTabs?: boolean;
  horizontalLineUnderTabs?: boolean;
  scrollable?: boolean;
}

export const Tabs = ({
  children,
  activeTab = null,
  setActiveTab = null,
  onTabChange = null,
  clickableTabs = true,
  horizontalLineUnderTabs = false,
  scrollable = false,
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- TODO: refactor to avoid conditional hook call
  if (!activeTab && !setActiveTab) [activeTab, setActiveTab] = React.useState<string>();

  useEffect(() => {
    setActiveTab(children.find((x) => x?.props?.showTab === true).props.label);
  }, []);

  const changeTab = (tab) => {
    setActiveTab(tab);
    if (onTabChange) onTabChange(tab);
  };

  let content;
  const buttons = [];

  React.Children.forEach(children, (child) => {
    if (!child) return;

    if (child.props.showTab) {
      buttons.push(child.props.label);
    }

    if (child.props.label === activeTab) content = child.props.children;
  });

  return (
    <>
      <TabButtons
        className={`${horizontalLineUnderTabs && 'underlined'}`}
        activeTab={activeTab}
        buttons={buttons}
        changeTab={changeTab}
        clickable={clickableTabs}
      />
      <div className={`tab-content ${scrollable && 'scrollable'}`}>{content}</div>
    </>
  );
};

const TabButtons = ({ buttons, changeTab, activeTab, clickable, className }) => {
  return (
    <div className={`tab-buttons ${className}`}>
      {buttons.map((button) => (
        <button
          key={button}
          className={`${button === activeTab && 'tab-buttons__active'} ${clickable && 'tab-buttons__clickable'} tab-buttons__tab-button`}
          onClick={() => {
            if (clickable) changeTab(button);
          }}>
          {button}
        </button>
      ))}
    </div>
  );
};

export interface TabProps {
  label: string;
  children: React.ReactNode;
  showTab: boolean;
}

export const Tab: React.FC<TabProps> = ({ children, label, showTab = true }) => {
  return <React.Fragment>{children}</React.Fragment>;
};
